import {
  DesktopHeader,
  Drawer,
  Header,
  layoutClasses,
  LayoutRoot,
  ModuleSection,
  ProfileMenuItem,
  ProfileSection,
  Spinner,
} from '@ifca-ui/core'
import {
  Home as HomeIcon,
  Logout as LogoutIcon,
  Profile as ProfileIcon,
  PxSalesCrm,
  PxSystemAdmin,
} from '@ifca-ui/icons/dist/index.esm'
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  useMediaQuery,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import SideMenuBg from 'assets/images/product/sidemenu-background.svg'
import HeaderBg from 'assets/images/header/header-bg.svg'
import clsx from 'clsx'
import AccessControl from 'component/AccessControl/AccessControl'
import AppContext, { AppContextProps } from 'containers/context/Context'
import { navigateReactUrl } from 'containers/helper/windowopen'
import { ACCT_PATH } from 'containers/modules/Account/Routes'
import { AUTH_PATH } from 'containers/modules/Authentication/Routes'
import * as React from 'react'
import { Suspense, useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Dialog, DialogData } from '../../component/Dialog/Dialog'
import {
  useGetAppAccessTokenLazyQuery,
  useGetSystemAdminAccessQuery,
  useGetUserProfileLazyQuery,
  useLogoutWithMicrosoftLazyQuery
} from '../../generated/graphql'
import {
  getUserProfile,
  setUserProfile,
  updateUserProfileObservable,
  UserProfile,
} from '../../UserDetail'
import { HOME_PATH } from '../modules/Home/Routes'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import { NOTIFICATION_SETUP_PATH } from '../modules/NotificationSetup/Routes'
import { navigationService } from 'navigationService'
import HeaderX from 'component/Header/HeaderX'
import { ClearAccessToken, clearAllCookies } from 'AccessToken'
interface Modules {
  name?: string
  path?: string
  url?: string
  application?: string | null
  icon?: any
  iconActived?: any
  ACL: number | number[] | null
}
interface MainLayoutProps {
  children?: React.ReactNode
  window?: () => Window
}
const MainLayout: React.FC<MainLayoutProps> = ({ children, window }) => {
  const nav = new navigationService()
  const navigate = useNavigate()
  const headerBgURL = HeaderBg
  const { pathname } = useLocation()
  const { rootState, rootDispatch } =
    React.useContext<AppContextProps>(AppContext)
  const [confirmDialog, setConfirmDialog] = useState(false)
  const [confirmDialogNavigation, setConfirmDialogNavigation] =
    useState<string>('')
    var msalInstance = rootState?.msalInstance
  //#region API call
  const [
    getProfile,
    {
      data: { profile: userProfile } = {
        profile: null,
      },
    },
  ] = useGetUserProfileLazyQuery({
    onCompleted: data => {
      if (data && data?.profile) {
        setUserProfile(data.profile as UserProfile)
      }
    },
  })
  
  const [
    logoutWithMicrosoft
  ] = useLogoutWithMicrosoftLazyQuery({
    fetchPolicy: 'network-only',
  })
  // console.log("uhuy",msalInstance?.getAccount())

  //Get items from server
  const [
    getAppAccessToken,
    {
      data: { getAppAccessToken: string } = {
        getAppAccessToken: null,
      },
    },
  ] = useGetAppAccessTokenLazyQuery({
    fetchPolicy: 'network-only',
  })

  //Get getSystemAdminAccess from server
  const {
    data: { getSystemAdminAccess } = {
      getSystemAdminAccess: null,
    },
  } = useGetSystemAdminAccessQuery({
    fetchPolicy: 'network-only',
  })

  //#endregion

  const ModulesList: Modules[] = [
    {
      name: 'Home',
      path: HOME_PATH.HOME_LIST,
      icon: <HomeIcon className="svg-icon" />,
      // iconActived: <WhiteHome className="svg-icon" />,
      ACL: null,
    },
    // {
    //   name: 'Access Security',
    //   path: ACCESS_SECURITY_PATH.ACCESS_SECURITY_MENU_LIST,
    //   icon: <AccessSecurityIcon className="svg-icon" />,
    //   // iconActived: <AccessSecurityIcon className="svg-icon" />,
    //   ACL: 1,
    // },
    {
      name: 'Sales CRM',
      //path: ACCESS_SECURITY_PATH.ACCESS_SECURITY_MENU_LIST,
      icon: <PxSalesCrm className="svg-icon" />,
      url: import.meta.env.VITE_APP_SALE_URL,
      // url: "http://localhost:4200/authentication/autologin/",
      application: 'Sales',
      // iconActived: <AccessSecurityIcon className="svg-icon" />,
      ACL: null,
    },
    {
      name: 'System Admin',
      //path: ACCESS_SECURITY_PATH.ACCESS_SECURITY_MENU_LIST,
      icon: <PxSystemAdmin className="svg-icon" />,
      // iconActived: <AccessSecurityIcon className="svg-icon" />,
      url: import.meta.env.VITE_APP_SYSTEMADMIN_URL,
      // url: "http://localhost:4200/authentication/autologin/",
      application: 'System Admin',
      ACL: getSystemAdminAccess?.length ? null : 1,
    },
    {
      name: 'Notification',
      path: NOTIFICATION_SETUP_PATH.NOTIFICATION_SETUP,
      icon: <NotificationsActiveIcon className="svg-icon" color="primary" />,
      ACL: null,
    },
    {
      name: 'Log Out',
      path: AUTH_PATH.LOGOUT,
      icon: <LogoutIcon className="svg-icon" />,
      ACL: null,
    },
    // {
    //   name: 'Sales Admin',
    //   icon: <PxSalesAdmin className="svg-icon" />,
    //   // iconActived: <AccessSecurityIcon className="svg-icon" />,
    //   url: import.meta.env.VITE_APP_SALEADMIN_URL,
    //   // url: "http://localhost:4400/autologin",
    //   application: "Sales Admin",
    //   ACL: 1,
    // }
  ]

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const theme = useTheme()
  const container =
    window !== undefined ? () => window().document.body : undefined
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const profileMenu = (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <ProfileMenuItem
        onClick={() => {
          if (!isDesktop) {
            handleDrawerOpen()
          }
          handleClose()
          confirmationDialogHandler(ACCT_PATH.PROFILE)
        }}
      >
        <ProfileIcon width="18px" height="18px" />
        Profile
      </ProfileMenuItem>
      <ProfileMenuItem
        onClick={() => {
          handleClose()
          confirmationDialogHandler(AUTH_PATH.LOGOUT)
        }}
      >
        <LogoutIcon width="18px" height="18px" />
        Logout
      </ProfileMenuItem>
    </Menu>
  )
  const handleDrawerOpen = () =>
    rootDispatch({ type: 'isDrawerOpen', payload: !rootState.isDrawerOpen })

  useEffect(() => {
    if (isDesktop && !rootState.isDrawerOpen) {
      document?.getElementById('main-header')?.classList.add('full-width')
      document
        ?.getElementById('subheader-container')
        ?.classList.add('full-width')
      document?.getElementById('footer')?.classList.add('full-width')
    } else {
      document?.getElementById('main-header')?.classList.remove('full-width')
      document
        ?.getElementById('subheader-container')
        ?.classList.remove('full-width')
      document?.getElementById('footer')?.classList.remove('full-width')
    }
  }, [rootState.isDrawerOpen, isDesktop])

  const handleMenuItemClick = (module: Modules) => {
    if (module.path) {
      confirmationDialogHandler(module.path)
    } else if (module.url) {
      if (module.application) {
        getAppAccessToken({
          variables: {
            appName: module.application,
          },
        }).then(a => {
          navigateReactUrl(module.url + '?q=' + a.data?.getAppAccessToken, '')
        })
      } else {
        navigateReactUrl(module.url, '')
      }
    }
  }

  useEffect(() => {
    updateUserProfileObservable().subscribe(x => {
      if (x) {
        getProfile()
      }
    })
    getProfile()
  }, [])

  const confirmationDialogHandler = async (route: string) => {
    if(route == '/logout'){
      clearAllCookies()
      ClearAccessToken();
      sessionStorage.clear()
      if (localStorage.getItem('login') == 'azr'){
        await msalInstance?.logoutPopup({postLogoutRedirectUri: "/login"}).then((response)=> {
          logoutWithMicrosoft()
        })
      }
      // navigate('/login');
      // msalInstance.logout(); // Log out dari aplikasi
    }else{
      if (rootState.contentIsModifiedFn && rootState.contentIsModifiedFn()) {
        setConfirmDialog(true)
        setConfirmDialogNavigation(route)
      } else {
        navigate(route)
      }
    }
  }

  // //#region Dialog
  const confirmationDialog = (
    <Dialog
      open={confirmDialog}
      onClose={() => setConfirmDialog(false)}
      useDefaultDialogHeader={true}
      useDefaultDialogBody={true}
      defaultDialogData={
        {
          header: {
            title: {
              leftTopTitle: {
                title: {
                  text: 'Exit Confirmation',
                },
              },
            },
          },
          bodyText:
            'Are you sure you want to exit? Your changes will not be saved.',
        } as DialogData
      }
      footer={{
        buttons: [
          {
            children: 'Cancel',
            color: 'primary',
            onClick: () => setConfirmDialog(false),
          },
          {
            children: 'Confirm',
            color: 'primary',
            onClick: e => {
              rootDispatch({
                type: 'contentIsModifiedFn',
                payload: () => {
                  return false
                },
              })
              setConfirmDialog(false)
              navigate(confirmDialogNavigation)
            },
          },
        ],
      }}
    />
  )
  // //#endregion

  function handle(ob) {
    if (!isDesktop) {
      handleDrawerOpen()
    }
    if (ob?.name === 'Home') {
      nav.clickSideBar(ob?.name)
      confirmationDialogHandler(ob.path)
    }
    if (ob?.name === 'Log Out') {
      confirmationDialogHandler(ob.path)
    }
    if (ob?.name === 'Notification') {
      nav.clickSideBar(ob?.name)
      confirmationDialogHandler(ob.path)
    } else if (ob.url) {
      if (ob.application) {
        getAppAccessToken({
          variables: {
            appName: ob.application,
          },
        }).then(a => {
          navigateReactUrl(ob.url + '?q=' + a.data?.getAppAccessToken, '')
        })
      } else {
        navigateReactUrl(ob.url, '')
      }
    }
  }

  return (
    <>
      {!userProfile ? (
        <Spinner />
      ) : (
        <LayoutRoot
          component="div"
          className={layoutClasses.root}
          display="flex"
        >
          {isDesktop ? (
            <DesktopHeader
              title="PropertyX Home"
              leftIcon={{
                props: {
                  onClick: () => handleDrawerOpen(),
                },
              }}
            />
          ) : null}

          <HeaderX isDesktop={isDesktop} />
          <Drawer
            container={container}
            onClose={handleDrawerOpen}
            // open={isDesktop ? rootState.isDrawerOpen : !rootState.isDrawerOpen}
            open={isDesktop ? rootState.isDrawerOpen : !rootState.isDrawerOpen}
            variant={isDesktop ? 'persistent' : 'temporary'}
          >
            <ProfileSection
              drawerImage={SideMenuBg}
              avatar={{
                src:
                  getUserProfile()?.avatar ??
                  'https://scontent.fkul8-1.fna.fbcdn.net/v/t1.6435-9/82939221_2922930267717357_668748647327858688_n.jpg?_nc_cat=109&ccb=1-5&_nc_sid=09cbfe&_nc_ohc=vj2htXI6WtoAX-3uAoA&_nc_ht=scontent.fkul8-1.fna&oh=42de33a80efda1ba65cfa21bc580c373&oe=617F4CC6',
              }}
              profile={{
                title: getUserProfile()?.name,
                subTitle: getUserProfile()?.email,
              }}
              dropDownIcon={{
                onClick: e => handleClick(e),
              }}
            />
            <ModuleSection as="div">
              <List disablePadding>
                {ModulesList.map((module, index) =>
                  module.ACL ? (
                    <AccessControl allowedPermissions={module.ACL}>
                      <ListItem
                        key={index}
                        dense
                        className={pathname === module.path ? 'active' : ''}
                        divider
                        // onClick={() => {
                        //   handleMenuItemClick(module)
                        // }}
                        onClick={() => handle(module)}
                      >
                        <ListItemIcon>{module.icon}</ListItemIcon>
                        <ListItemText
                          primary={module.name}
                          primaryTypographyProps={{
                            variant: 'inherit',
                          }}
                        />
                      </ListItem>
                    </AccessControl>
                  ) : (
                    <ListItem
                      key={index}
                      dense
                      divider
                      className={pathname === module.path ? 'active' : ''}
                      // onClick={() => {
                      //   handleMenuItemClick(module)
                      // }}
                      onClick={() => handle(module)}
                    >
                      <ListItemIcon>{module.icon}</ListItemIcon>
                      <ListItemText
                        primary={module.name}
                        primaryTypographyProps={{
                          variant: 'inherit',
                        }}
                      />
                    </ListItem>
                  )
                )}
              </List>
            </ModuleSection>
          </Drawer>
          {profileMenu}
          {confirmationDialog}
          <Box
            component="main"
            className={clsx(layoutClasses.mainContent, {
              [layoutClasses.contentShift]: rootState.isDrawerOpen,
            })}
          >
            <Suspense fallback={<Spinner />}>
              <div style={{ height: `${rootState.headerHeight}px` }} />
              <Outlet />
            </Suspense>
          </Box>
        </LayoutRoot>
      )}
    </>
  )
}
export default MainLayout
